import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { NavLink } from 'react-router-dom';
import * as dvr from 'utils/dvr';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const DVRNavigation = ({ links }) => {
  const dataLayerPush = (action) => {
    window.dataLayer.push({
      event: 'GA_event',
      eventCategory: 'nav|digital-IVR',
      eventAction: action,
      eventLabel: window.location.pathname,
    });
  };

  const servicesLink = useCallback(() => {
    links.find((i) => i.page === 'Services');
  },
  [links]);

  const detalizationLink = useCallback(() => {
    links.find((i) => i.page === 'Detalization');
  },
  [links]);

  return (
    <div className={cx('component')}>
      {servicesLink && (
      <NavLink
        className={cx('link')}
        to={servicesLink.path}
        onClick={() => {
          dataLayerPush('Подключенные услуги');
          dvr.playWaw('IVR_usl.wav');
          window.scrollTo(0, 0);
        }}
      >
        Подключенные услуги
      </NavLink>
      )}
      {detalizationLink && (
      <NavLink
        className={cx('link')}
        to={`${detalizationLink.path}/last-expenses`}
        onClick={() => {
          dataLayerPush('5 последних списаний');
          dvr.playWaw('IVR_detal.wav');
          window.scrollTo(0, 0);
        }}
      >
        5 последних списаний
      </NavLink>
      )}
      {detalizationLink && (
      <NavLink
        className={cx('link')}
        to={`${detalizationLink.path}/last-payments`}
        onClick={() => {
          dataLayerPush('Последние платежи');
          dvr.playWaw('Idr_vash_platez.wav');
          window.scrollTo(0, 0);
        }}
      >
        Последние платежи
      </NavLink>
      )}
      <span
        className={cx('link')}
        onClick={() => {
          dataLayerPush('Доступные тарифы');
          dvr.playWaw('IVR_tp.wav', '/customers/products/mobile/tariffs/');
        }}
        role="link"
        tabIndex="0"
      >
        Доступные тарифы
      </span>
      <span
        className={cx('link')}
        onClick={() => {
          dataLayerPush('Доступные услуги');
          dvr.playWaw('IVR_usl_2.wav', '/customers/products/mobile/services/');
        }}
        role="link"
        tabIndex="0"
      >
        Доступные услуги
      </span>
    </div>
  );
};

DVRNavigation.propTypes = {
  links: PropTypes.array,
};

export default DVRNavigation;
